<div class="w-12 flex-column flex-middle">
    @for (section of component.sections; track $index; let isLast = $last) {
    <div class="w-12">
        <div class="c-6 c-11-m c-11-s m-r-0 m-b-7 m-b-10-s"
             [ngClass]="{'m-b-0 m-b-0-s': isLast}">
            <div class="h4"
                 [ngClass]="[ section.subtitle_aligment || 'left', section.subtitle_color || 'col-1' ]"
                 *iCms="'subtitle' of section; content: 'html'">
            </div>
            <p class="m-t-5 col-11 p2"
               [ngClass]="[ section.subtitle_aligment || 'left', section.copy_color || 'col-11' ]"
               *iCms="'copy' of section; content: 'html'">
            </p>
        </div>
    </div>
    }
</div>
